<!--
 * @Author: your name
 * @Date: 2020-08-13 10:21:34
 * @LastEditTime: 2022-10-27 14:19:23
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/FooterBar/index.vue
-->
<style scoped lang="sass">
.van-button--default
  border: none

.disabled
  background: rgba(221, 221, 221, 1) !important
  color: rgba(141, 150, 160, 1) !important

.footer_bar
  width: 100%
  display: flex
  height: 58px
  background: #fff

  .left
    flex: 1
    display: flex
    align-items: center
    justify-content: center
    height: 100%
    border-top: 1px solid #f1f2f3

  .right
    flex: 1
    display: flex
    align-items: center
    justify-content: center

    .button
      height: 100%
      width: 100%
      border: none
      color: #fff

      .content
        font-weight: 500
</style>

<style lang="sass" scoped>
.van-button--normal
  padding: 0 !important
</style>

<template lang="pug">
.footer_bar
  van-button.left(v-if="isButton")
    slot(name='left')
  .left(v-if="!isButton")
    slot(name='left')
  .right
    van-button(
      type='primary'
      :style="{ background: disabled ? disableBackgroundColor : '' }"
      :disabled="disabled" @click="click"
      :class="{'disabled': disabled}"
    ).button
      .price
        slot(name='price')
      span.content.ls1 {{ content }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapState } from 'vuex'
import { t } from '@/utils/language'

@Component({
  props: {
    status: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      currentLanguage: state => state.language?.currentLanguage,
    }),
    content() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      if (this.status === 1) {
        return this.t('pay_now', 'PAY NOW')
      } else if (this.status === 2) {
        return this.t('add_to_cart', 'ADD TO CART')
      } else if (this.status === 3) {
        return this.t('place_order', 'PLACE ORDER')
      } else if (this.status === 4) {
        return this.t('view_cart', 'VIEW CART')
      } else if (this.status === 5) {
        return this.t('not_taking_orders', 'NOT TAKING ORDERS')
      } else if (this.status === 6) {
        return this.t('submit', 'SUBMIT')
      } else if (this.status === 7) {
        return this.t('select_a_size', 'SELECT A SIZE')
      }
    }
  }
})
class FooterBar extends Vue {
  disableBackgroundColor = '#dddddd !important'
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  click() {
    this.$emit('clickButton')
  }
}

export default FooterBar
</script>
